import React, { useEffect } from "react";
import useStateContext from "../hooks/useStateContext";
import logo from "../assets/images/logo.png";
import Center from "./Center";
import { useLocation } from "react-router-dom";
import {
  TimesUpMessage,
  NoInternetMessage,
  ThankYouMessage,
} from "../constants/constant";

const Result = () => {
  const location = useLocation();
  const dynamicValue = location.state?.value
    ? (localStorage.setItem("dynamicValue", location.state.value),
      location.state.value)
    : localStorage.getItem("dynamicValue") || 1;

  const value = parseInt(dynamicValue, 10);
  const { resetContext } = useStateContext();
  const message =
    value === 1
      ? TimesUpMessage
      : value === 2
      ? ThankYouMessage
      : NoInternetMessage;
  useEffect(() => {
    resetContext();
  }, []);
  return (
    <>
      <div className="result-wrapper">
        <div className="result-container">
          <div className="img-container">
            <img src={logo} alt="logo" style={{ width: "200px" }} />
          </div>
          <h1
            dangerouslySetInnerHTML={{
              __html: message,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Result;
